"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHistoricalDataBySlug = getHistoricalDataBySlug;
async function getHistoricalDataBySlug(slug) {
    return await fetch(`${this.baseUrl}/Play/Games/GetHistoricalDataBySlug/${slug}`)
        .then(x => x.json())
        .then(x => x)
        .catch(() => ({ error: { code: "networkError", message: "A network error happened" } }));
}
//# sourceMappingURL=getHistoricalDataBySlug.js.map